import React from 'react';
import styled from 'styled-components';

const SpotifyContainer = styled.div`
  position: relative;
  height: 9.5rem;
  overflow: hidden;
  margin-top: 1.5rem;
  border-radius: 0.5rem;
`;

const StyledIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 0;
  height: ${({ height }) => (height ? height : '100%')};
`;

type SpotifyPlayerProps = {
  albumid?: string;
  height?: string;
};

/**
 *
 * Use the `spotify-player` shortcode to embed spotify player matching a albumId (albumid can be obtained from embed URL).
 *
 * ex: for https://open.spotify.com/embed/album/3ZnRypvLKFfwTw4KSpLIXz
 *
 * albumid is `3ZnRypvLKFfwTw4KSpLIXz`
 *
 * Example Use:
 *
 * ```js
 * {spotify-player albumid="3ZnRypvLKFfwTw4KSpLIXz"}
 * ```
 *
 */

const SpotifyPlayer: React.FC<React.PropsWithChildren<SpotifyPlayerProps>> = ({
  albumid,
  height,
  ...otherProps
}) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const isPlaylist = otherProps['isplaylist'];
  return (
    <SpotifyContainer {...{ paddingBottom: height || '150px', ...otherProps }}>
      <StyledIFrame
        src={`https://open.spotify.com/embed/${
          isPlaylist === '1' ? `playlist` : `album`
        }/${albumid}`}
        loading="lazy"
        height={'152px'}
        {...otherProps}
      />
    </SpotifyContainer>
  );
};

export default SpotifyPlayer;
